import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { StepperBuilderService } from '../../../../../../avisDePub/creer/services/stepper.builder.service';
import { FormInputErrorTools } from '../../../../../../shared/components/form-input/form-input-error/utils/form-input-error.tools';
import { FormulaireServiceService } from '../../../../../services/formulaire-service.service';

@Component({
  selector: 'app-table-modal',
  templateUrl: './table-modal.component.html',
  styleUrls: ['./table-modal.component.scss']
})
export class TableModalComponent implements OnInit {

  @Input() fields: any;
  @Input() modalValue: any;
  @Input() isRawValue = false;
  @Input() dataEntries = new Map();
  @Input() arrayElem = '';
  @Input() title = '';
  @Input() linkForRouter;
  @Output() submitValues: EventEmitter<boolean> = new EventEmitter();

  onClose: any;
  tempForm = new FormGroup({});
  modalErrors: any[] = [];
  stepStats = new Map<string, boolean>();
  modalOpen = true;

  constructor(public activeModal: NgbActiveModal,
    private stepBuilder:StepperBuilderService, private formulaireService: FormulaireServiceService) { }

  ngOnInit(): void {
  }

  concatField(field){
    return field;
  }

  close(el: HTMLElement){
    if(this.onClose != 'false') {
      this.clearErrors();
      this.getErrorModal(this.tempForm,this.stepStats);
      for (const error of this.modalErrors) {
        this.stepBuilder.addStepFieldsOnErrors('modal', error.idInput, error.message);
      }
      if(this.modalErrors.length != 0 ){
        el.scrollIntoView()
      } else {
        this.clearErrors();
        this.activeModal.close({bool:this.onClose,formValue:this.tempForm.value});
      }
    } else {
      this.modalOpen=false;
      this.clearErrors();
      this.activeModal.close({bool:this.onClose,formValue:this.tempForm.value});
    }

  }

  clearErrors(){
    this.modalErrors = [];
    this.stepBuilder.clearSpecificFieldOnErrors('modal');
    this.stepStats.set('modal',true);
  }


  submitModal(bool:string,el: HTMLElement){
    this.onClose = bool;
    this.close(el);
  }

  public getErrorModal(obj, stepStats, formControlName = '') {
    function isPlainObject(input) {
      return input && !Array.isArray(input) && typeof input === 'object';
    }

    if (Array.isArray(obj.controls)) { return obj.controls.map(e => { this.getErrorModal(e, stepStats, formControlName); }); }
    if (!isPlainObject(obj)) return obj;

    if (obj.controls === undefined) {
      if (obj.errors || obj.invalid) {
        stepStats.set(obj.prefixEform, false);
        obj.touched = true;
        Object.keys(obj.errors).forEach(error => {
          this.modalErrors.push({
            'prefixEform': obj.prefixEform,
            'idInput': obj.idInput,
            'message': this.formulaireService.mapErrorToMessage(error, obj,
              this.stepBuilder.stepFieldsSpecificMessages.get(formControlName)).replace('{{id}}',obj.idInput.split('|').pop().split('_')[0].replace('undefined','')).replace('{{type}}',obj.type.toUpperCase()) +
              " - " + obj.idInput.split('|').pop().split('_')[0].replace('undefined','')
          });
        });
        formControlName = '';

      }
    } else {
      Object.keys(obj.controls).forEach(key => {
        formControlName = formControlName == '' ? key : formControlName + '.' + key;
        this.getErrorModal(obj.controls[key], stepStats, formControlName);
      });
    }
  }

  hasError(){
    return this.stepBuilder.getStepFieldsOnErrors('modal')?.length > 0
  }

  getRepeatablePathWithIndexForInput = (field) : string => {
    return '';
  }

}

class submitContent {
  exit : boolean;
  values : any;
}
